import { FC, useEffect, useState } from 'react';

import { Button, Modal, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import { useTranslation } from 'react-i18next';

import useAuth from '@/hooks/useAuth';
import PlansModal from '@/pages/Organization/Payments/PlansModal';

import Wrapper from './styles';

const HeaderTrial: FC = () => {
  const { i18n, t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [days, setDays] = useState<number>();
  const { user, isMembershipActive } = useAuth();
  const date = dayjs(user?.organization.subscription.periodEndDate).locale(
    i18n.language
  );
  const formattedDate =
    i18n.language === 'tr'
      ? date.format('D MMMM YYYY')
      : date.format('MMMM D, YYYY');

  useEffect(() => {
    if (user?.isVerified && user.organization.subscription.plan.name) {
      const leftDay = dayjs(user.organization.subscription.periodEndDate).diff(
        Date.now(),
        'days'
      );
      setDays(leftDay);
    }
  }, [user]);

  const handleModalClose = () => {
    setIsModalVisible(false);
  };
  const handleRenewClick = () => {
    setIsModalVisible(true);
  };

  //TODO ADD UPGRADE PLAN PAGE

  if (isMembershipActive || (days && days < 7)) {
    return (
      <Wrapper>
        <Row className="duration-tag" align="middle">
          {isMembershipActive ? (
            <Typography.Text className="text fs-14-regular">
              {t('header.trial.ended')}
              <span className="fs-14-bold"> {t('header.trial.renew')}</span>
            </Typography.Text>
          ) : (
            <Typography.Text className="text fs-14-regular">
              {t('header.trial.endsIn.prefix')}{' '}
              <span className="fs-14-bold">{days}</span>{' '}
              {t('header.trial.endsIn.suffix')}{' '}
              <span className="fs-14-bold">{formattedDate}</span>{' '}
              {t('header.trial.endsIn.on')}
            </Typography.Text>
          )}
          <Button type="default" className="btn" onClick={handleRenewClick}>
            {t('header.trial.renew')}
          </Button>
        </Row>
        <Modal
          open={isModalVisible}
          onCancel={handleModalClose}
          footer={null}
          destroyOnClose
          centered
          width={'100%'}
        >
          <PlansModal />
        </Modal>
      </Wrapper>
    );
  } else {
    return null;
  }
};

export default HeaderTrial;
